<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	//import Buttons from './Buttons'
	import Navbar from './Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			//'buttons': Buttons,
			'navbar': Navbar,
		},
		data () {
			return {
				resource: null,

				media: null,
				data: null,
				last_request: null,

				qr: {
					value: window.location.href,
				}
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getStatus() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
					if(this.data.last_request) {
						this.loadRequest()
					}
					this.resource = 'admin/customers/' + this.data.id
				}).catch(function(response) {
					console.log(response)
				})
			},
			reloadData() {
				this.getData()
			},
			loadRequest() {
				if(this.data.last_request) {
					var that = this
					this.last_request = []
					var fields = ['structure_id', 'structure_categories_id', 'structure', 'length', 'width', 'area', 'comments']
					fields.forEach(function(field) {
						var find = that.data.last_request.data.find(function(element) {
							return element.id == field
						})
						if(find) {
							that.last_request.push(find)
						}
					})
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Show.vue